import { TourState, TourStep } from '../models/interfaces'

/**
 * Getters del módulo de tour
 */
export const getters = {
  /**
   * Retorna el tour activo actualmente
   */
  activeTour: (state: TourState) => state.activeTour,

  /**
   * Retorna el índice del paso actual
   */
  currentStepIndex: (state: TourState) => state.currentStepIndex,

  /**
   * Retorna el paso actual del tour
   */
  currentStep: (state: TourState): TourStep | null => {
    if (!state.activeTour) return null
    return state.activeTour.steps[state.currentStepIndex] || null
  },

  /**
   * Retorna si hay un tour activo
   */
  isActive: (state: TourState) => state.isActive,

  /**
   * Retorna si los tours están habilitados globalmente
   */
  isTourEnabled: (state: TourState) => state.isTourEnabled,

  /**
   * Retorna el historial de tours completados
   */
  tourHistory: (state: TourState) => state.tourHistory,

  /**
   * Retorna si un tour específico ha sido completado
   */
  isTourCompleted: (state: TourState) => (tourId: string) => {
    return state.tourHistory.includes(tourId)
  },

  /**
   * Retorna el progreso actual del tour (porcentaje)
   */
  tourProgress: (state: TourState): number => {
    if (!state.activeTour || state.activeTour.steps.length === 0) return 0
    return Math.round(((state.currentStepIndex + 1) / state.activeTour.steps.length) * 100)
  },

  /**
   * Retorna el número total de pasos del tour activo
   */
  totalSteps: (state: TourState): number => {
    if (!state.activeTour) return 0
    return state.activeTour.steps.length
  },

  /**
   * Retorna si se está en el primer paso del tour
   */
  isFirstStep: (state: TourState): boolean => {
    return state.currentStepIndex === 0
  },

  /**
   * Retorna si se está en el último paso del tour
   */
  isLastStep: (state: TourState): boolean => {
    if (!state.activeTour) return false
    return state.currentStepIndex === state.activeTour.steps.length - 1
  },
}
